<template>
  <div>
    <div class="mao">
      <a
        href="#yi"
        class="it"
        @click="select(1)"
        :class="{ active: val === 1 }"
      >
        一级注册造价工程师
      </a>
      <a
        href="#er"
        class="it"
        @click="select(2)"
        :class="{ active: val === 2 }"
      >
        二级注册造价工程师
      </a>
      <a
        href="#qi"
        class="it"
        @click="select(3)"
        :class="{ active: val === 3 }"
      >
        其他专职专业人员
      </a>
    </div>
    <a id="yi" class="them" style="margin-top: 32px">
      <div class="line"></div>
      一级注册造价工程师
      <div class="des">
        共：<span class="number">{{ oneConut }}</span
        >人
      </div>
    </a>
    <el-table :data="oneList" class="tableControll" empty-text="暂无数据">
      <el-table-column
        style="margin-left: 30px"
        type="index"
        label="序号"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="name" label="姓名" align="center">
      </el-table-column>
      <el-table-column prop="idcard" align="center" label="身份证号">
      </el-table-column>
      <el-table-column prop="cert_number" align="center" label="注册证书编号">
      </el-table-column>
    </el-table>
    <a id="er" class="them" style="margin-top: 52px">
      <div class="line"></div>
      二级注册造价工程师
      <div class="des">
        共：<span class="number">{{ twoConut }}</span
        >人
      </div>
    </a>
    <el-table :data="twoList" class="tableControll" empty-text="暂无数据">
      <el-table-column
        style="margin-left: 30px"
        type="index"
        label="序号"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="name" label="姓名" align="center">
      </el-table-column>
      <el-table-column prop="idcard" align="center" label="身份证号">
      </el-table-column>
      <el-table-column prop="cert_number" align="center" label="注册证书编号">
      </el-table-column>
    </el-table>
    <a id="qi" class="them" style="margin-top: 52px">
      <div class="line"></div>
      其他专职专业人员
      <div class="des">
        共：<span class="number">{{ otherConut }}</span
        >人
      </div>
      <div class="des" style="margin-left: 51px">
        高级职称人数：<span class="number">{{ otherGao }}</span
        >人
      </div>
      <div class="des" style="margin-left: 51px">
        中级职称人数：<span class="number">{{ otherZhong }}</span
        >人
      </div>
    </a>
    <el-table :data="otherList" class="tableControll" empty-text="暂无数据">
      <el-table-column
        style="margin-left: 30px"
        label="序号"
        type="index"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="name" label="姓名" align="center">
      </el-table-column>
      <el-table-column prop="idcard" align="center" label="身份证号">
      </el-table-column>
      <el-table-column
        prop="cert_name"
        align="center"
        label="具备执(从)业资格证书名称"
      >
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <span>
            <el-link
              style="font-size: 12px"
              @click="goDetail(scope.row)"
              class="handle"
              >查看详情
            </el-link>
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="专职专业人员详情"
      :close-on-click-modal="false"
      :visible.sync="perDetail"
      width="540px"
    >
      <div class="contControll">
        <div class="them"></div>
        <div class="cont">
          <div class="item">
            <div class="text">姓名</div>
            <div class="detail">{{ line.name }}</div>
          </div>
          <div class="item">
            <div class="text">身份证号</div>
            <div class="detail">{{ line.idcard }}</div>
          </div>
          <div class="item">
            <!--            {{ line }}&#45;&#45;&#45;&#45;&#45;&#45;-->
            <!--            {{ line.idcard_f_image }}-->
            <div class="text">身份证（正面）</div>
            <div class="detail">
              <a :href="line.idcard_f_image" target="_blank" class="link"
                >查看文件</a
              >
            </div>
          </div>
          <div class="item">
            <div class="text">身份证（反面）</div>
            <div class="detail">
              <a :href="line.idcard_b_image" target="_blank" class="link"
                >查看文件</a
              >
            </div>
          </div>
          <div class="item">
            <div class="text">专业</div>
            <div class="detail">{{ line.major }}</div>
          </div>
          <div class="item">
            <div class="text">联系电话</div>
            <div class="detail">{{ line.phone }}</div>
          </div>
          <div class="item">
            <div class="text">职称</div>
            <div class="detail">{{ line.title }}</div>
          </div>
          <div class="item">
            <div class="text">具备执(从)业资格证书名称</div>
            <div class="detail">{{ line.cert_name }}</div>
          </div>
          <div class="item">
            <div class="text">注册证书编号</div>
            <div class="detail">{{ line.cert_number }}</div>
          </div>
          <div class="item">
            <div class="text">证书有效期</div>
            <div class="detail">
              {{ line.cert_exp_time }}
            </div>
          </div>
          <div class="item">
            <div class="text">具备执（从）业资格证书</div>
            <div class="detail">
              <a :href="line.cert_image" target="_blank" class="link"
                >查看文件</a
              >
            </div>
          </div>
          <div class="item">
            <div class="text">职称证书</div>
            <div class="detail">
              <a :href="line.title_image" target="_blank" class="link"
                >查看文件</a
              >
            </div>
          </div>
        </div>
      </div>
      <!--      <span slot="footer" class="dialog-footer">-->
      <!--        <el-button type="primary" @click="perDetail = false">确 定</el-button>-->
      <!--      </span>-->
    </el-dialog>
  </div>
</template>

<script>
import { getStaff } from "@/api/staff.js";

export default {
  name: "zzStaffDetail",
  data() {
    return {
      val: 1,
      dialogVisible: false,

      otherConut: "", //其他的人数
      otherList: [], //其他列表
      otherGao: "", //其他高级
      otherZhong: "", //其他中级

      oneConut: "", //一级的人数
      oneList: [], //一级列表

      twoConut: "", //二级的人数
      twoList: [], //二级列表

      perDetail: false,

      line: {}, //每一行的值
    };
  },
  created() {
    this.init();
  },
  props: {
    detail: {
      type: Number,
      default: null,
    },
  },
  methods: {
    goDetail(val) {
      this.line = val;
      this.perDetail = true;
    },
    select(val) {
      this.val = val;
    },
    async init() {
      const res = await getStaff(this.detail);

      this.otherConut = res.level0.count;
      this.otherGao = res.level0.gao;
      this.otherZhong = res.level0.zhong;
      this.otherList = res.level0.list;

      this.oneConut = res.level1.count;
      this.oneList = res.level1.list;

      this.twoConut = res.level2.count;
      this.twoList = res.level2.list;
    },
  },
};
</script>

<style lang="less" scoped>
.mao {
  display: flex;
  align-items: center;
  margin-top: 30px;

  .it {
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    cursor: pointer;
    border: 1px solid #dddddd;
    color: #666666;
    text-decoration: unset;
  }

  .active {
    background: #e4ecff;
    border: 1px solid #4379f6;
    text-align: center;
    color: #4379f6;
  }
}

.them {
  display: flex;
  align-items: center;
  position: relative;
  font-size: 14px;
  font-weight: 700;
  color: #333333;
  padding-left: 15px;

  .line {
    width: 4px;
    height: 16px;
    background: #4379f6;
    left: 0px;
    position: absolute;
  }

  .des {
    font-size: 14px;
    color: #666666;
    margin-left: 20px;
    font-weight: 400;

    .number {
      font-size: 16px;
      font-family: "BEBAS";
      color: #333333;
      font-weight: 700;
      margin-right: 5px;
    }
  }
}

.add {
  width: 100px;
  height: 32px;
  background: #4379f6;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #ffffff;
  margin-top: 18px;
}

.tableControll {
  width: 100%;
  border: solid 1px rgb(235, 238, 245);
  border-bottom: unset;
  margin-top: 18px;
}

/deep/ .el-table th {
  background: #f6f6f6 !important;
  color: #666;
  font-weight: normal;
}

/deep/ .el-table tr {
  color: #333 !important;
  font-size: 12px;
}

/deep/ .el-table__empty-text {
  line-height: unset;
}

/deep/ .el-form--label-top .el-form-item__label {
  padding: unset;
  font-size: 12px;
  color: #666666;
}

/deep/ .el-form-item__label {
  line-height: unset;
}

/deep/ .el-input__inner {
  margin-top: 5px;
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #dddddd;
}

/deep/ .el-dialog__footer {
  background: #f5f5f5;
  height: 70px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 30px;
}

.dialog-footer {
  /deep/ .el-button--primary {
    width: 100px;
    background: #f39020;
  }

  /deep/ .el-button {
    padding: unset;
    width: 100px;
    height: 32px;
    border-radius: unset;
  }
}

.t {
  margin-top: 20px;
  font-size: 12px;
  color: #666666;
}

.mt5 {
  margin-top: 5px;
}

.contControll {
  display: flex;
  align-items: flex-start;

  .them {
    min-width: 110px;
    font-size: 12px;
    font-weight: 700;
    color: #333333;
  }

  .cont {
    flex: 1;

    .item {
      display: flex;
      align-items: center;
      margin-top: 16px;

      &:first-child {
        margin-top: unset;
      }

      .text {
        font-size: 12px;
        color: #999999;
        width: 190px;
      }

      .detail {
        font-size: 12px;
        color: #333333;
      }

      .check {
        font-size: 12px;
        color: #4379f6;
        cursor: pointer;
      }
    }
  }
}
</style>
